/**
 * Fill in the blanks player — routes by config.blankMode
 */

import * as React from 'react';
import type { ElementPlayerProps } from '@ai-content-hub/content-kit';
import type { FITBElementData, FITBAnswer } from './schema';
import { getFITBBlankMode } from './schema';
import { FITBPlayerDrag } from './FITBPlayerDrag';
import { FITBPlayerDropdown } from './FITBPlayerDropdown';
import { FITBPlayerType } from './FITBPlayerType';

export type FITBPlayerProps = ElementPlayerProps<FITBElementData, FITBAnswer> & {
    flashBlankId?: string | null;
    showGenericDragInstructions?: boolean;
};

export const FITBPlayer: React.FC<FITBPlayerProps> = (props) => {
    const mode = getFITBBlankMode(props.config);
    if (mode === 'drag') return <FITBPlayerDrag {...props} />;
    if (mode === 'dropdown') return <FITBPlayerDropdown {...props} />;
    return <FITBPlayerType {...props} />;
};
